import { purchasingTransactionBeforeSave } from "services/sosInventoryService/purchasingTransaction/beforeSave";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.PURCHASE_ORDER.fullString;

export function beforeSave(record) {
  const newRecord = purchasingTransactionBeforeSave(OBJECT_TYPE, record);
  return newRecord;
}
